export const TYPOGRAPHY = {
    "display": "Hornbill, Poppins, ui-rounded, system-ui, sans-serif",
    "text": "'Source Sans 3', 'Source Sans Pro', -apple-system, 'Segoe UI', Roboto, sans-serif"
};
export const THEMES = {
    "dark": {
        "bg": "#060D11",
        "ink": "#E9F0F3",
        "dim": "#BDC6CA",
        "faint": "#8F9AA0",
        "surface": "#131B1F",
        "surface2": "#1A2226",
        "metricbg": "#0C1418",
        "pop": "#222A2E",
        "bd": "#2D3A40",
        "bd2": "#405058",
        "trackbg": "#1A2226",
        "accent": "#48B2DE",
        "accentText": "#7FD0F5",
        "indigo": "#5CBEE9",
        "pos": "#7CC58C",
        "warn": "#D4AA5A",
        "neg": "#EF958C",
        "accentInk": "#0B1A22",
        "surfaceInverse": "#FFFFFF",
        "barbg": "#0C1418",
        "spark": "#6F7C83"
    },
    "light": {
        "bg": "#FAFDFE",
        "ink": "#152127",
        "dim": "#424F56",
        "faint": "#55636A",
        "surface": "#FFFFFF",
        "surface2": "#EDF1F3",
        "metricbg": "#F3F7F9",
        "pop": "#E6EAEC",
        "bd": "#D9DFE2",
        "bd2": "#C4CCD0",
        "trackbg": "#EDF1F3",
        "accent": "#0580A7",
        "accentText": "#005E7C",
        "indigo": "#016484",
        "pos": "#006E30",
        "warn": "#755402",
        "neg": "#9A322E",
        "accentInk": "#FFFFFF",
        "surfaceInverse": "#FFFFFF",
        "barbg": "#F3F7F9",
        "spark": "#8A979E"
    }
};
export const DEFAULT_THEME = "dark";
//# sourceMappingURL=generated-tokens.js.map